module.exports = __webpack_public_path__ + "static/media/MLT.27b3a1e7.png";